import { Injectable } from '@angular/core';
import { DatasourceDomain } from '@mode/shared/contract-common';
import { QueryOptions, Definition } from '@mode/shared/data-access-algolia';
import { AlgoliaSuggestionService } from './algolia-suggestion.service';
import { SuggestionService } from './suggestion.service';
import { DataIndexSuggestionService } from './data-index-suggestion.service';

@Injectable()
export class DualDispatchSuggestionService implements SuggestionService {
  constructor(
    private _algoliaSuggestionService: AlgoliaSuggestionService,
    private _dataIndexSuggestionService: DataIndexSuggestionService
  ) {}

  getTables(
    datasource: DatasourceDomain.Datasource,
    opts: QueryOptions<any>,
    isCompletingDefinition: boolean
  ): Promise<AceAjax.Completion[]> {
    try {
      this._dataIndexSuggestionService.getTables(datasource, opts, isCompletingDefinition);
    } catch (error) {
      console.error('Call to DataIndex failed:', error);
    }
    return this._algoliaSuggestionService.getTables(datasource, opts, isCompletingDefinition);
  }

  getColumns(
    datasource: DatasourceDomain.Datasource,
    opts: QueryOptions<'table' | 'dataSourceTable'>,
    suggestedTable: string
  ): Promise<AceAjax.Completion[]> {
    try {
      this._dataIndexSuggestionService.getColumns(datasource, opts);
    } catch (error) {
      console.error('Call to DataIndex failed:', error);
    }
    return this._algoliaSuggestionService.getColumns(datasource, opts, suggestedTable);
  }

  getDefinition(opts: QueryOptions<'definition'>): Promise<Definition | null> {
    try {
      this._dataIndexSuggestionService.getDefinition(opts);
    } catch (error) {
      console.error('Call to DataIndex failed:', error);
    }
    return this._algoliaSuggestionService.getDefinition(opts);
  }
}
